import React from 'react';

import { Content } from './Content.js';

export default class PipedContentHeader extends React.Component {

  render() {
    var title = (this.props.section)
      ? Content[this.props.page][this.props.section].title
      : Content[this.props.page].title
    ;

    var sectionClass = (this.props.section)
      ? this.props.section
      : ''
    ;

    return (
      <div className={`PipedContentHeader row ${sectionClass}`}>
        <div className="inner col-xs-16">
          <h2>{title}</h2>
        </div>
        <div className="strokes">
          <div className="stroke-mask left"></div>
          <div className="stroke-mask right"></div>
          <div className="stroke horizontal"></div>
          <div className="stroke vertical left"></div>
          <div className="stroke vertical right"></div>
        </div>
      </div>
    );
  }

};
